import DysonV15 from '@app/assets/images/products/v15.png'
import DysonSubmarine from '@app/assets/images/products/submarine.png'
import DysonGen5 from '@app/assets/images/products/gen5.png'
import Dyson360 from '@app/assets/images/products/360vis.png'
import VacuumImgFr from '@app/assets/images/fr/banner-vacuums.png'
import langPacks from '@app/lang'
import { parse } from 'date-fns'
import type { Program } from './programs.types'

const today = new Date()

const france: Program = {
  id: 'FR',
  urlSegment: 'fr',
  supportedLanguages: ['en', 'fr'],
  defaultLanguage: 'fr',
  languagePack: langPacks.france,
  products: [
    { name: 'Dyson Gen5™', img: DysonGen5 },
    { name: 'Dyson V15™', img: DysonV15 },
    { name: 'Dyson V15 Submarine™', img: DysonSubmarine },
    { name: 'Dyson 360 Vis Nav™', img: Dyson360 },
  ],
  retailers: [
    'Dyson en ligne',
    'Dyson Opéra, Paris',
    'Dyson Parly 2, Le Chesnay',
    'Dyson La Part-Dieu, Lyon',
    'Dyson Les Terrasses du Port, Marseille',
  ],
  startDate: parse('26-04-2024', 'dd-MM-yyyy', new Date()),
  endDate: parse('20-06-2024', 'dd-MM-yyyy', new Date()),
  bannerImg: VacuumImgFr,
  traded_products: [
    { value: 'Dyson' },
    { value: 'Rowenta' },
    { value: 'Dreame' },
    { value: 'Tineco' },
    { value: 'Samsung' },
    { value: 'Autres' },
    { value: 'Other', localeKey: 'tradein_q1_option_2' },
  ],
  offer_strategy: 'combined_sku',
  offer_rules: {
    v15: [
      { with: 'Dyson', value: 100 },
      { with: 'Rowenta', value: 100 },
      { with: 'Dreame', value: 100 },
      { with: 'Tineco', value: 100 },
      { with: 'Samsung', value: 100 },
      { with: 'Autres', value: 100 },
      { with: 'Other', value: 100 },
    ],
    gen5: [
      { with: 'Dyson', value: 150 },
      { with: 'Rowenta', value: 150 },
      { with: 'Dreame', value: 150 },
      { with: 'Tineco', value: 150 },
      { with: 'Samsung', value: 150 },
      { with: 'Autres', value: 150 },
      { with: 'Other', value: 150 },
    ],
    submarine: [
      { with: 'Dyson', value: 180 },
      { with: 'Rowenta', value: 180 },
      { with: 'Dreame', value: 180 },
      { with: 'Tineco', value: 180 },
      { with: 'Samsung', value: 180 },
      { with: 'Autres', value: 180 },
      { with: 'Other', value: 180 },
    ],
    vis360: [
      { with: 'Dyson', value: 300 },
      { with: 'Rowenta', value: 300 },
      { with: 'Dreame', value: 300 },
      { with: 'Tineco', value: 300 },
      { with: 'Samsung', value: 300 },
      { with: 'Autres', value: 300 },
      { with: 'Other', value: 300 },
    ],
  },
  closed: today > new Date(CAMPAIGN_END_DATE_FR),
  partner_url: 'https://www.dyson.fr/',
  logo_url: undefined,
}

export default france
